export default "__VITE_ASSET__az0Y2Rk$__"